/**
 * Check if the current environment is in electron
 */
export const isElectron = () => !!(window as any).process

/**
 * Set the page title
 */
export const setPageTitle = (title: string) => {
    document.title = `Volt · ${title}`
}

/**
 * Get the app base url
 */
export const baseUrl = () => `${window.location.origin}/`

/**
 * Convert a keybind string to appropriate symbols
 */
export const keybindToSymbols = (keybind: string): string =>
    keybind
        .replace(/cmd/i, '⌘')
        .replace(/orctrl/i, '')
        .replace(/option/i, '⌥')
        .replace(/shift/i, '⇧')
        .replace(/ctrl/i, '⌃')
        .replace(/win/i, '⊞')

/**
 * Download a file
 */
export const downloadFile = (filename: string, content: string): void => {
    const encodedURI = encodeURI(`data:text/csv;charset=utf-8,${content}`)
    const link = document.createElement('a')
    link.setAttribute('href', encodedURI)
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
}

/**
 * Constrain a value between the min and max provided
 */
export const constrain = (value: number, min: number, max: number): number =>
    Math.max(min, Math.min(value, max))
